
import apiRequest from './apiRequest';

const organizationApi = {
    async createOrginazitionDetails( isData, token) {
        const url = `/api/v1/invoicing/organizations`;
        return apiRequest(url, 'POST', token, isData);
    },

    async getOrginazitionDetails(orgId, token) {
        const url = `/api/v1/invoicing/organizations/${orgId}`;
        return apiRequest(url, 'GET', token);
    },

    async getOrginazitionDetailsList( token) {
        const url = `/api/v1/invoicing/organizations?page=0&size=20&sortBy=name&sortDirection=ASC`;
        return apiRequest(url, 'GET', token);
    },
    async getOrginazitionAllDetailsList( token) {
        const url = `/api/v1/invoicing/organizations/all`;
        return apiRequest(url, 'GET', token);
    },

    async updateOrginazitionDetails(orgId, isData, token) {
        const url = `/api/v1/invoicing/organizations/${orgId}`;
        return apiRequest(url, 'PUT', token, isData);
    },

    async deleteOrginazitionDetails(orgId, token) {
        const url = `/api/v1/invoicing/organizations/${orgId}`;
        return apiRequest(url, 'DELETE', token);
    },
};

export default organizationApi;
